import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { MatrixRoomStatus } from '../models/MatrixRoom';
/**
 * A service to help with matrix room management
 */

export var MatrixRoomService = /*#__PURE__*/function () {
  function MatrixRoomService(httpClient) {
    _classCallCheck(this, MatrixRoomService);

    this.httpClient = httpClient;
  }
  /**
   * Create a room
   *
   * @param accessToken
   * @param config
   */


  _createClass(MatrixRoomService, [{
    key: "createRoom",
    value: function createRoom(accessToken) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.httpClient.post('/createRoom', config, {
                  accessToken: accessToken
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Invite a user to a room
     *
     * @param accessToken
     * @param user
     * @param room
     */

  }, {
    key: "inviteToRoom",
    value: function inviteToRoom(accessToken, user, room) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(room.status !== MatrixRoomStatus.JOINED && room.status !== MatrixRoomStatus.UNKNOWN)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", Promise.reject("User is not a member of room ".concat(room.id, ".")));

              case 2:
                return _context2.abrupt("return", this.httpClient.post("/rooms/".concat(encodeURIComponent(room.id), "/invite"), {
                  user_id: user
                }, {
                  accessToken: accessToken
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Join a specific room
     *
     * @param accessToken
     * @param room
     */

  }, {
    key: "joinRoom",
    value: function joinRoom(accessToken, room) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(room.status === MatrixRoomStatus.JOINED)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", Promise.resolve({
                  room_id: room.id
                }));

              case 2:
                return _context3.abrupt("return", this.httpClient.post("/rooms/".concat(encodeURIComponent(room.id), "/join"), {}, {
                  accessToken: accessToken
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Get all joined rooms
     *
     * @param accessToken
     */

  }, {
    key: "getJoinedRooms",
    value: function getJoinedRooms(accessToken) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.httpClient.get("/joined_rooms", undefined, {
                  accessToken: accessToken
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return MatrixRoomService;
}();